// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__0HsyI","active":"Navigation_active__pVJbe","nav":"Navigation_nav__WsgPa"};